import ReactGA from 'react-ga4';
import {env} from 'utils/helpers';

export const pageView = (data = {}) => {
  if (env('REACT_APP_ENV') !== 'production') {
    return;
  }
  ReactGA.send({
    hitType: 'pageview',
    ...data,
  });
};

export const initGA = () => {
  if (env('REACT_APP_ENV') !== 'production') {
    return;
  }
  ReactGA.initialize(env('REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID'));
};
